import type { UseMutateAsyncFunction, UseQueryOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

export const TipoDocumentoEnum = {
  CNH: 'CNH',
  RG: 'RG',
  CPF: 'CPF',
  CertidaoDeNascimento: 'CertidaoDeNascimento',
  CertidaoDeCasamento: 'CertidaoDeCasamento',
  ComprovanteDeResidencia: 'ComprovanteDeResidencia',
  Procuracao: 'Procuracao',
  OutroDocumento: 'OutroDocumento',
  ComprovanteDePagamento: 'ComprovanteDePagamento',
  Checklist: 'Checklist',
  CartaoCNPJ: 'CartaoCNPJ',
  ContratoSocial: 'ContratoSocial',
  UltimaAlteracao: 'UltimaAlteracao',
  CertidaoJuntaComercial: 'CertidaoJuntaComercial',
  ComprovanteDeEnderecoDaEmpresa: 'ComprovanteDeEnderecoDaEmpresa',
  CertificadoDeRegistroCivil: 'CertificadoDeRegistroCivil',
  DocumentoDeIdentificacion: 'DocumentoDeIdentificacion',
  PreAprobacionAprobacionBancaria: 'PreAprobacionAprobacionBancaria',
  ReciboDeServicio: 'ReciboDeServicio',
  Mandato: 'Mandato',
  CarpetaTributaria: 'CarpetaTributaria',
  CertificacionDePoderes: 'CertificacionDePoderes',
  InicioDeActividadEnServicioDeSii: 'InicioDeActividadEnServicioDeSii',
  PublicacionDeExtractoOficial: 'PublicacionDeExtractoOficial',
  RutEmpresa: 'RutEmpresa',
} as const

export type TTipoDocumento = keyof typeof TipoDocumentoEnum

export type TPersonInfo =
  | {
      tipo: 'proposta'
      nome: string
      tipoComprador: string
      documento?: string
    }
  | { tipo: 'lead_represado'; nome: string; documento?: string | null }

export type TEnviarDocumentoParams = { arquivo: File; tipo: TTipoDocumento; documentId: string }
export type TEnviarDocumentoResponse = { documentId: string; sucesso: boolean }

export type TDocumentoDefault = {
  id: string
  tipo: TTipoDocumento
  nome?: string
  tamanho?: string
  arquivo?: File
  dataEnvio?: string
}
export type TDocumentoSucesso = { status: 'success' } & TDocumentoDefault
export type TDocumentoError = { status: 'error' } & TDocumentoDefault
export type TDocumentoEnviando = { status: 'uploading' } & TDocumentoDefault
export type TDocumentoRecuperado = { status: 'recovered'; tipo: TTipoDocumento; id: string; dataEnvio?: string }

export type TDocumentoAnexado = TDocumentoSucesso | TDocumentoError | TDocumentoEnviando | TDocumentoRecuperado

export type TDocumentoEnviado = {
  dataEnvio: string
  tipo: TTipoDocumento
}

export type TDocumentoPersistido = {
  documentoId: string
  tipoDeDocumento: TTipoDocumento
  dataEnvio: string
}

export type TDocumentoRetornado = TDocumentoEnviado | TDocumentoPersistido

export type TDocumentosPessoa = {
  pessoaId?: string
  nome?: string
  documentos: TDocumentoRetornado[]
}

export interface TEnvioDocumentosConfig {
  pessoa: TPersonInfo
  documentTypes: Array<{ value: TTipoDocumento; label: string }>
  backButtonText: string
  enviarDocumentoMutation: UseMutateAsyncFunction<TEnviarDocumentoResponse, Error, TEnviarDocumentoParams, unknown>
  recuperarDocumentosQuery: UseQueryOptions<TDocumentosPessoa, AxiosError, TDocumentoAnexado[], readonly unknown[]>
}

export interface TEnvioDocumentosContext {
  config: TEnvioDocumentosConfig
  documentosEnviados: TDocumentoAnexado[]
  setDocumentosEnviados: React.Dispatch<React.SetStateAction<TDocumentoAnexado[]>>
  tipoDocumento: TTipoDocumento | undefined
  setTipoDocumento: React.Dispatch<React.SetStateAction<TTipoDocumento | undefined>>
  arquivoAnexado: File | null
  setArquivoAnexado: React.Dispatch<React.SetStateAction<File | null>>
  handleEnviarArquivo: () => void
  handleRetry: (documentId: string) => Promise<void>
  handleDelete: (documentId: string) => void
}
